import { MAX_UNREAD_BADGE } from '../Chat/constants'
import type { ChatPanelUnread } from './hooks/useChatPanelUnread'

export type ToolbarChatBadge = number | null

/**
 * Badge for the toolbar chat icon: how many chats are waiting, capped at
 * MAX_UNREAD_BADGE. Shown whatever the panel is doing — having chat open is not the
 * same as having read every conversation. There is no other source: the removed
 * legacy BadgeService was never initialised, so its total was always 0.
 */
export function computeToolbarChatBadgeContent(panelUnread?: ChatPanelUnread): ToolbarChatBadge {
  if (panelUnread && panelUnread.chats > 0) {
    return Math.min(panelUnread.chats, MAX_UNREAD_BADGE)
  }
  return null
}

/** Sidebar Chat item dot: hidden with nothing unread, red when a chat holds a mention. */
export function chatNavDot(unread: ChatPanelUnread): { visible: boolean; color: 'error' | 'primary' } {
  return { visible: unread.chats > 0, color: unread.mentionChats > 0 ? 'error' : 'primary' }
}
